/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-01 10:14:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-12-31 11:52:47
 * @FilePath: /src/components/GlobalDialog/TermsConditionsDialog/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { fetchJSONValue } from '@/api/public';
import PopupResponsive from '@/components/PopupResponsive';
import { Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
interface TermsConditionsDialogProps {
  show: boolean;
  onClose: () => void;
}

export default function TermsConditionsDialog({ show, onClose }: TermsConditionsDialogProps) {
  const [innerText, setInnerText] = useState<string>('');

  const [loading, setLoading] = useState(false);
  const getBlockValue = async () => {
    setLoading(true);
    const { data } = await fetchJSONValue(['terms_conditions']);

    // @ts-ignore: JSON.parse returns any type and terms_conditions structure is not fully typed
    const _innerText = JSON.parse(data?.terms_conditions?.json_value) || { text: '' };
    // @ts-ignore: _innerText structure from JSON is not strictly typed
    setInnerText(_innerText?.text || '');

    setLoading(false);
  };

  useEffect(() => {
    if (show && !innerText) {
      getBlockValue();
    }
  }, [show]);

  return (
    <PopupResponsive
      open={show}
      onClose={onClose}
      height="80%"
      title=""
      showDivider={false}
      sx={{
        '& .popup-content': {
          padding: '16px 14px',
          overflowX: 'hidden',
        },
      }}
    >
      <div className="bg-white rounded-lg w-full relative">
        {loading ? (
          <div className="flex flex-col gap-4 items-center justify-center h-full">
            <Skeleton animation="wave" width="100%" height={40} variant="text" />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
            <Skeleton animation="wave" width="100%" height={40} />
          </div>
        ) : (
          <div className={styles.inner} dangerouslySetInnerHTML={{ __html: innerText }} />
        )}
      </div>
    </PopupResponsive>
  );
}
